import { API } from "@/lib/api";
import { APIService } from "@/services/api";
import { ReadShift, WriteShift } from "@/types/shift";

export const ShiftsService = new APIService<ReadShift, WriteShift>(API.Shifts);
